<script lang="ts">
  import type { BankMatch } from "../types";
  import { formatSortCode } from "../../../lib/formatting";
  import Bank from "~icons/ph/bank";
  import Check from "~icons/ph/check-bold";

  let {
    bankMatch,
    showHeader = false,
  }: {
    bankMatch: BankMatch;
    showHeader?: boolean;
  } = $props();

  // copAccountHolder is only used for 'Close Match' result
  let accountHolder = $derived(bankMatch.copAccountHolder || bankMatch.accountHolder);
</script>

<div class="bank-account-info relative">
  {#if bankMatch.result === "match"}
    <div
      class="absolute -top-[11px] right-4 text-sm font-medium text-emerald-700 bg-emerald-100 py-[1px] pl-1.5 pr-2 rounded-badge flex gap-2 items-center">
      <Check class="w-4 h-4" />Verified
    </div>
  {/if}

  <dl>
    {#if showHeader}
      <span class="inline-flex items-center gap-1 text-gray-500 text-xs font-medium mb-4">
        <Bank class="w-[18px] h-[18px]" /> Your bank info
      </span>
    {/if}
    <dt>Bank name</dt>
    <dd>{bankMatch.bankName}</dd>
  </dl>
  <dl>
    <dt>Account holder</dt>
    <dd>{accountHolder}</dd>
  </dl>
  <dl>
    <dt>Account number</dt>
    <dd>{bankMatch.accountNumber}</dd>
  </dl>

  <dl>
    <dt>Sort code</dt>
    <dd>{formatSortCode(bankMatch.sortCode)}</dd>
  </dl>
</div>

<style lang="postcss">
  .bank-account-info {
    @apply border rounded-lg px-4 divide-y mb-4;

    dl {
      @apply py-4;
    }

    dd {
      @apply text-gray-500;
    }
  }
</style>
